import React from 'react'

import moment from 'moment'
import styled from 'styled-components'

import { theme } from 'app/match/applicationReportPDF/assets/theme'
import * as helpers from 'app/sm/helpers'

const HeaderApp = styled.header`
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  color: #fff;
  font-size: 14px;
  padding: 5px 0 6px;
  margin-bottom: 22px;
  .container {
    background: rgba(153, 153, 153, 0.5);
  }
  @media print {
    font-size: 12px;
    padding: 3px 0 4px;
    margin-bottom: ${theme.space[3]}px;
  }
`

const HeaderText = styled.div`
  width: 100% !important;
  @media print {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: rgba(153, 153, 153, 0.5) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    font-size: 12px;
    padding: 3px 0 4px;
    margin-bottom: ${theme.space[3]}px;
  }
`

const PropHeading = styled.h2`
  padding: ${theme.dividedSpace[2]}px;
  font-size: ${theme.fontSizes[4]}px;
  font-weight: ${theme.fontWeights.mid};
  margin: 0 !important;
  color: #fff !important;
`

const PropTime = styled.time`
  padding: ${theme.dividedSpace[2]}px;
  font-size: ${theme.fontSizes[4]}px;
  font-weight: ${theme.fontWeights.mid};
  color: #fff !important;
`

const Header = () => {
  const today = moment().format(helpers.dateWithWeekDayTimeFormat)
  return (
    <HeaderApp className="header">
      <div className="container">
        <HeaderText className="headertext d-flex justify-between">
          <PropHeading>Rental Properties</PropHeading>
          <PropTime>{today}</PropTime>
        </HeaderText>
      </div>
    </HeaderApp>
  )
}

export default Header
